
import React from 'react';
import { Helmet } from 'react-helmet';
import TermsOfService from '../components/termsofservice';
import Navigation from '../components/navigation'
import Footer from '../components/footer'
const TermsOfServicePage = (props) => {
  return (
    <div className='container'>
            <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta property="og:title" content="Cysigil Network Pvt Ltd" />
        <link
          rel="canonical"
          href="https://www.cysigil.com"
        />
      </Helmet>
      <Navigation />
        <TermsOfService />
        <Footer />
    </div>
      
  );
};

export default TermsOfServicePage;
